import { Component, OnInit } from '@angular/core';
import { IDashboardMidwifePayload, ISearchMidwifeBody } from 'src/app/models/dashboard.models';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-find-your-midwife',
  templateUrl: './find-your-midwife.component.html',
  styleUrls: ['./find-your-midwife.component.scss']
})
export class FindYourMidwifeComponent implements OnInit {

  midwifes: Array<IDashboardMidwifePayload> = [];
  body: ISearchMidwifeBody;
  loading: boolean = true;

  constructor(public homeService: HomeService) { }

  ngOnInit(): void {
    this.body = {
      offset: 0,
      limit: 5,
      minimumExperience: "4",
      sortingCriteria: "EXPERIENCE_DESC",
    };
    this.getMidwifeList();
  }

  getMidwifeList(){
    this.homeService.searchMidwife(this.body)
    .subscribe((res)=>{
      console.log("Home/Find-your-midwife:",res);
      this.midwifes = res.payload;
      this.loading = false;
    },err=>{
      console.error("Home/Find-your-midwife Error:",err);
    });
  }

}
